<template>
  <v-dialog
    attach
    v-model="cdatepickergebu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="computedDateFormatted"
        :disabled="pass50"
        :label="selectedLang.PersonalDataTile50"
        persistent-hint
        prepend-icon="event"
        :rules="[(v) => !!v || selectedLang.PersonalDataTile51 + '']"
        readonly
        v-on="on"
        required
      ></v-text-field>
    </template>
    <v-date-picker
      ref="cdatepickergebu"
      v-model="date"
      :first-day-of-week="1"
      locale="de-DE"
      :max="maxGeb"
      no-title
      @input="cdatepickergebu = false"
      @change="onChangeD"
    ></v-date-picker>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
export default {
  data: function () {
    return {
      date: "",
      cdatepickergebu: false,
    };
  },
  watch: {
    cdatepickergebu(val) {
      val &&
        setTimeout(() => (this.$refs.cdatepickergebu.activePicker = "YEAR"));
    },
  },
  computed: {
    ...mapState(["selectedLang", "maxGeb", "pass50"]),
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    onChangeD() {
      var xy = this.formatDate(this.date);
      this.computedDateFormatted = xy;
      this.$emit("update", xy);
    },
  },
};
</script>
